module.exports = __webpack_public_path__ + "static/media/about-us-1.15b49f6e.jpg";